import styled from 'styled-components';
import Icon from '../../../atoms/Icon';

const StyledIcon = styled(Icon)`
  margin: 0 25px;
`;

/**
 * @param {LinkedIconProps} props
 * @returns {React.ReactElement} The rendered component
 */
const LinkedIcon = ({ href, type, className }) => (
  <a
    href={href}
    rel="noopener noreferrer"
    target="_blank"
    className={className}
  >
    <StyledIcon icon={type} />
  </a>
);

export default LinkedIcon;
